import React, { Fragment } from "react";

const SimpleTable = ({
  heading,
  rowHead1,
  rowHead2,
  Row1,
  Row2,
  Row3,
  rowHead3,
}) => {
  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          width: "95%",
          marginLeft: "auto",
          marginRight: "auto",
          overflowX: "auto",
        }}
      >
        <table className="table">
          <thead>
            <tr>
              <td> </td>
              {heading}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{rowHead1}</td>
              {Row1}
            </tr>
            <tr>
              <td>{rowHead2}</td>
              {Row2}
            </tr>
            {Row3 && rowHead3 ? (
              <tr>
                <td>{rowHead3}</td>
                {Row3}
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SimpleTable;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/common/simpleTable.js